import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../containers/actions/common/uiStateActions";

//files
import Header from "./Header";
// import SideBar from "./SideBar";
import SideBarIndex from "./SideBarIndex";

const drawerWidth = 300;

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: "flex",
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      backgroundColor: "#ffffff",
      boxShadow: "none",
      borderBottom: "1px solid #707070",
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(6) + 2,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(7) + 4,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(2),
      overflowX: "auto",
    },
  }),
  // Give preference to debug the MUI css issue
  { index: 1 }
);

export default function MiniDrawer({ children, ...props }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const reduxSideBarOpen = useSelector(
    (state) => state.pcmp.common.uiState.sideBarOpen
  );
  
  // Sync local state with Redux state
  React.useEffect(() => {
    setOpen(reduxSideBarOpen);
  }, [reduxSideBarOpen]);

  const handleDrawerOpen = () => {
    const newState = !open;
    setOpen(newState);
    dispatch(toggleSidebar(newState));
  };

  const handleOpen = () => {
    setOpen(true);
    dispatch(toggleSidebar(true));
  };

  const handleDrawerClose = () => {
    setOpen(false);
    dispatch(toggleSidebar(false));
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={`${reduxSideBarOpen ? "side-bar-open" : "side-bar-closed"} ${classes.appBar}`}>
        <Header handleDrawerOpen={handleDrawerOpen} />
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar} />
        {/* <SideBar
          sideBarOpen={open}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleOpen}
        /> */}
        <SideBarIndex
          sideBarOpen={open}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleOpen}
        />
      </Drawer>
      <main
        className={classes.content}
        onMouseEnter={() => handleDrawerClose()}
      >
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  );
}
